import script from "./AcademyArticle1.vue?vue&type=script&setup=true&lang=js"
export * from "./AcademyArticle1.vue?vue&type=script&setup=true&lang=js"

import "./AcademyArticle1.vue?vue&type=style&index=0&id=9daf292e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9daf292e"]])

export default __exports__